module.exports = __webpack_public_path__ + "img/map_mobile_1.63c086f0.png";